import {
  defaultLangFunction,
  localizeLoaderFactory,
} from '$core/helpers/ngx-translate';
import { environment } from '$env/environment';
import { Location } from '@angular/common';
import { NgModule } from '@angular/core';
import { NoPreloading, RouterModule, Routes } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import {
  LocalizeParser,
  LocalizeRouterModule,
  LocalizeRouterService,
  LocalizeRouterSettings,
} from 'localize-router';
import { StaticResolver } from './core/services/static.service';
import { ShellComponent } from './core/shell/shell.component';

const routes: Routes = [
  {
    path: '',
    component: ShellComponent,
    resolve: {
      static: StaticResolver,
    },
    children: [
      {
        path: 'error',
        loadChildren: () =>
          import('./modules/error-pages/error-pages.module').then(
            (m) => m.ErrorBlogPagesModule
          ),
      },
      {
        path: 'employees',
        loadChildren: () =>
          import('./modules/employees/employees.module').then(
            (m) => m.EmployeesModule
          ),
      },
      {
        path: 'files',
        loadChildren: () =>
          import('./modules/files/files.module').then((m) => m.FilesModule),
      },
      {
        path: '',
        loadChildren: () =>
          import('./modules/blog/blog.module').then((m) => m.BlogModule),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      enableTracing: false,
      preloadingStrategy: NoPreloading,
      useHash: false,
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
      onSameUrlNavigation: 'ignore',
    }),
    LocalizeRouterModule.forRoot(routes, {
      parser: {
        provide: LocalizeParser,
        useFactory: localizeLoaderFactory,
        deps: [TranslateService, Location, LocalizeRouterSettings],
      },
      cacheName: environment.localStorageKeys.lang,
      alwaysSetPrefix: false,
      defaultLangFunction: defaultLangFunction,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {
  constructor(private localizeRouterService: LocalizeRouterService) {}
}
